"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getYoutubeThumbnail = void 0;
function getYoutubeThumbnail(id) {
    return `https://img.youtube.com/vi/${encodeURI(id)}/hqdefault.jpg`;
}
exports.getYoutubeThumbnail = getYoutubeThumbnail;
//# sourceMappingURL=get-youtube-thumbnail.js.map